import { render, staticRenderFns } from "./FeatureCollection.vue?vue&type=template&id=4bc409d1&scoped=true&"
import script from "./FeatureCollection.vue?vue&type=script&lang=js&"
export * from "./FeatureCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc409d1",
  null
  
)

export default component.exports